import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import type { RootState, AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useMemoSelector = <T>(selectorFactory: () => (state: RootState) => T, deps: any[] = []) =>
    useAppSelector(useMemo(selectorFactory, deps));